<p>embedded-power-bi-report works!</p>
@if (isEmbedded) {
  <powerbi-report
    [embedConfig]="reportConfig"
    [cssClassName]="reportClass"
    [phasedEmbedding]="phasedEmbeddingFlag"
    [eventHandlers]="eventHandlersMap"
    >
  </powerbi-report>
}
